import React, { useState, useEffect, useRef, useMemo } from "react";
import Box2D from "box2dweb";
import { THREE } from "expo-three";
import context from "./context";
import { useFrame } from "@react-three/fiber";
import { CollisionsManager } from "../World/EventsManager";
import CharactersLoop from "../World/CharactersLoop";
import HitPhysics from "../World/HitPhysics";
import useCappedFrame from "../../hooks/useCappedFrame";

const b2World = Box2D.Dynamics.b2World;
const b2Vec2 = Box2D.Common.Math.b2Vec2;
const b2BodyDef = Box2D.Dynamics.b2BodyDef;
const b2Body = Box2D.Dynamics.b2Body;
const b2FixtureDef = Box2D.Dynamics.b2FixtureDef;
const b2ContactListener = Box2D.Dynamics.b2ContactListener;

function emptyCallback() {
  return false;
}
export default function Provider({ children, onReady }) {
  const [world, setWorld] = useState();
  const [clock] = useState(new THREE.Clock());
  const refs = {};
  const bodies = [];
  let destroyQueue = [];
  const actions = {
    impulse: () => {},
  };
  // console.log(world?.IsLocked());
  useCappedFrame(() => {
    if (world && !world.IsLocked()) {
      // if (!world.IsLocked()) {
      // }
      CharactersLoop(refs);
      const timestep = clock.getDelta(); // 1 / 60
      world.Step(1 / 60, 10, 8);
      while (destroyQueue.length) {
        world.DestroyBody(destroyQueue.pop());
      }
    }
  });
  useEffect(() => {
    const gravity = new b2Vec2(0, 0);
    var world = new b2World(gravity, true);

    const contactListener = new b2ContactListener();
    contactListener.BeginContact =
      CollisionsManager.dispatchOnBeginContact.bind(CollisionsManager);
    contactListener.EndContact =
      CollisionsManager.dispatchOnEndContact.bind(CollisionsManager);
    world.SetContactListener(contactListener);
    world.SetContinuousPhysics(true);

    CollisionsManager.onEndContact(HitPhysics);

    setWorld(world);
    return () => {
      // destroy world ??
    };
  }, []);
  // const api = useMemo(() => ({ bodies, world, refs, actions }), [bodies, world, refs, actions])
  const api = { bodies, world, refs, actions, destroyQueue };
  if (onReady) {
    onReady(api);
  }
  return <context.Provider value={api}>{children}</context.Provider>;
}
